import {Pipe, PipeTransform} from '@angular/core';
import {cloneDeep, isEqual, remove, some} from 'lodash-es';
import {ProductionScheduleListviewColumn} from '../production-schedule-listview-column.interface';

@Pipe({
  name: 'getUnpinnedColumns'
})
export class GetUnpinnedColumnsPipe implements PipeTransform {
  public transform(
    visibleColumns: ProductionScheduleListviewColumn[],
    pinnedLeftColumns: ProductionScheduleListviewColumn[],
    pinnedRightColumns: ProductionScheduleListviewColumn[]
  ): ProductionScheduleListviewColumn[] {
    const unpinnedColumns = cloneDeep(visibleColumns);

    remove(unpinnedColumns, (unpinnedColumn: ProductionScheduleListviewColumn) => some(pinnedLeftColumns, (pinnedColumn: ProductionScheduleListviewColumn) => isEqual(unpinnedColumn, pinnedColumn)));

    remove(unpinnedColumns, (unpinnedColumn: ProductionScheduleListviewColumn) => some(pinnedRightColumns, (pinnedColumn: ProductionScheduleListviewColumn) => isEqual(unpinnedColumn, pinnedColumn)));

    return unpinnedColumns;
  }
}
